export function FieldError({ children }: { children?: string }) {
  if (!children) return null;
  return <span class="text-sm text-red-600 dark:text-red-400">{children}</span>;
}
